import request from '@/service/api'
import ConfigType from '@/service/api/type'
import qs from 'qs'
//统计分析
enum StatisticalEnumApi {
  // 收货记录查询
  RECEIVE_RECORD = '/CollectList/Page',//查询
  V_RECEIVE_RECORD = '/CollectList/PageList',//查询
  PURCHASE_COLLECT_LIST='/CollectList/PurchaseCollectList',  // 查询采购收货列表
  RECEIVE_RECORD_export = '/CollectList/CollectList',//查询导出
  
  RECEIVE_RECORD_DETAILSDATA = '/CollectDelivery/detailPage',//详情
  TEST_RECORD_DETAILSDATA = '/CollectList/EditIsQualified',//质检按钮
  TEST_RECORD_DELETE = '/CollectList/DeleteCollect',//删除按钮

  RECEIVE_RECORD_DOWNLOADIMG = '/sysFileInfo/preview',//图片预览
  CONtROLFILED = '/CollectDelivery/UpdIsQualified',//控制合格按钮
  RECEIVE_RECORD_TIME = '/CollectDelivery/sameDayCollectDelivery',//根据时间查询收货记录
  RECEIVE_RECORD_PRINT = '/CollectDelivery/print',//打印当天收货记录
  DINGDING = '/CollectList/DeliveryQualityDetailsPage',//钉钉质检结果查询
  DINGDINGUPDATA = '/CollectList/ReturnDeliveryNo',//钉钉质检结果更新
  DINGQUALIFIED = '/CollectList/BatchEditQualified',//钉钉批量更新
  
  // 库存列表
  INVENTORY_SEARCH = '/StockList/page',//查询
  INVENTORY_SEARCH_RECORD = '/WareStock/sameDayStockDetails',//根据时间查询库存记录
  INVENTORY_PRINT_RECORD = '/WareStock/print',//根据时间打印库存记录
  INVENTORY_SEARCHDETAILS = '/WareStock/detailPage',//详情
  INVENTORY_UPDATA = '/StockList/InventoryAttribute',//详情
  UpdateStockProject = '/StockList/UpdateStockProject',//修改项目号
  AddStockProject = '/StockList/AddStockProject',//新增项目库存数
  ErpOrderDetails = '/RuKu/ErpOrderDetails',//新增项目库存数
  PcInStock = '/RuKu/PcInStock',//新增项目库存数
  
  // 历史任务
  HISTORY_TASK = '/HistoryTask/Page',//历史任务主表
  // HISTORY_CHILD_TASK = '/WareTask/detailPage',//历史任务子表
  //库位视图
  LOCATIONVIEW = '/LoactionView/View',//列表
  LOCATIONVIEWAREA = '/Area/list',
  LOCATIONVIEW_DETAIL = '/LoactionView/GetLocationDetail',//库位详情  
  LOCATIONVIEW_UPDATE = '/LoactionView/UpdateAttribute',//更新库位属性
  LOCATIONVIEW_LOCK = '/LoactionView/LockLocation',//锁定库位
  LOCATIONVIEW_AREAROW = '/LoactionView/AreaRow',//根据库区获取排
  

  // 出入明细
  INANDOUTDETAILS = '/AccessRecord/Page',

  // 仓库统计
  GETUSER='/WareTask/GetUser', // 获取人员列表
  GETREPORTFORMS='WareTask/GetReportForms',  //查询仓库报表信息


  // 报表查询
  Moreexport='/deep-seek-report/moreexport',  //获取数据
}
//********************************收货记录查询*******************************//
//查询导出
export const getReceiveRecord = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.RECEIVE_RECORD}?${qs.stringify(data)}`,
    method: 'get'
  })
}

//收货记录视图查询
export const getPageList = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.V_RECEIVE_RECORD}?${qs.stringify(data)}`,
    method: 'get'
  })
}

//  查询采购收货列表
export const getPurchaseCollectList = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.PURCHASE_COLLECT_LIST}?${qs.stringify(data)}`,
    method: 'get'
  })
}

export const getReceiveexport = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.RECEIVE_RECORD_export}?${qs.stringify(data)}`,
    method: 'get'
  })
}
//详情
export const getReceiveRecordDetailsData = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.RECEIVE_RECORD_DETAILSDATA}?${qs.stringify(data)}`,
    method: 'get'
  })
}
//质检结果
export const TestingRecordDetailsData = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.TEST_RECORD_DETAILSDATA}`,
    method: 'post',
    data
  })
}
//质检删除
export const TestingRecorddelete = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.TEST_RECORD_DELETE}`,
    method: 'post',
    data
  })
}

//钉钉质检
export const dingdingDetailsData = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.DINGDING}?${qs.stringify(data)}`,
    method: 'get'
  })
}
export const dingdingupdataData = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.DINGDINGUPDATA}?${qs.stringify(data)}`,
    method: 'get'
  })
}
export const dingQualified = (data: any): ConfigType<any> => {
  return request({
    url: StatisticalEnumApi.DINGQUALIFIED,
    method: 'post',
    data
  })
}

//根据时间查询收货记录
export const receiptrecord = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.RECEIVE_RECORD_TIME}?${qs.stringify(data)}`,
    method: 'get'
  })
}
//打印当天收货记录
export const print_record = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.RECEIVE_RECORD_PRINT}?${qs.stringify(data)}`,
    method: 'get'
  })
}
// 图片预览
export const getImgSee = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.RECEIVE_RECORD_DOWNLOADIMG}?${qs.stringify(data)}`,
    method: 'get',
    responseType: 'blob'
  })
}
export const controlFields = (data: any): ConfigType<any> => {
  return request({
    url: StatisticalEnumApi.CONtROLFILED,
    method: 'post',
    data
  })
}
//********************************库存列表*******************************//
// 查询
export const getInventoryList = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.INVENTORY_SEARCH}?${qs.stringify(data)}`,
    method: 'get'
  })
}
// 根据时间查询库存记录
export const getlocalList = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.INVENTORY_SEARCH_RECORD}?${qs.stringify(data)}`,
    method: 'get'
  })
}
// 根据时间打印库存记录
export const printlocalList = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.INVENTORY_PRINT_RECORD}?${qs.stringify(data)}`,
    method: 'get'
  })
}
// 详情
export const getInventoryDetailsList = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.INVENTORY_SEARCHDETAILS}?${qs.stringify(data)}`,
    method: 'get'
  })
}

export const updatamaterial = (data: any): ConfigType<any> => {
  return request({
    url: StatisticalEnumApi.INVENTORY_UPDATA,
    method: 'post',
    data
  })
}
export const updateStockProject = (data: any): ConfigType<any> => {
  return request({
    url: StatisticalEnumApi.UpdateStockProject,
    method: 'post',
    data
  })
}
export const AddStockProject = (data: any): ConfigType<any> => {
  return request({
    url: StatisticalEnumApi.AddStockProject,
    method: 'post',
    data
  })
}
export const ErpOrderDetails = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.ErpOrderDetails}?${qs.stringify(data)}`,
    method: 'get'
  })
}

export const PcInStock = (data: any): ConfigType<any> => {
  return request({
    url: StatisticalEnumApi.PcInStock,
    method: 'post',
    data
  })
}
 
//********************************历史任务*******************************//
// 历史任务主表
export const getHistoryTask = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.HISTORY_TASK}?${qs.stringify(data)}`,
    method: 'get'
  })
}
// //历史任务子表
// export const getHistoryChildTask = (data: any): ConfigType<any> => {
//   return request({
//     url: `${StatisticalEnumApi.HISTORY_CHILD_TASK}?${qs.stringify(data)}`,
//     method: 'get'
//   })
// }
//********************************库位视图*******************************//
export const getLocationView = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.LOCATIONVIEW}?${qs.stringify(data)}`,
    method: 'get'
  })
}

export const detailLocationView = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.LOCATIONVIEW_DETAIL}?${qs.stringify(data)}`,
    method: 'get'
  })
}
export const AreaRow = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.LOCATIONVIEW_AREAROW}?${qs.stringify(data)}`,
    method: 'get'
  })
}

export const getAreaInfo = () => {
  return request({
    url: StatisticalEnumApi.LOCATIONVIEWAREA,
    method: 'get'
  })
}
export const updateLocationView = (data: any): ConfigType<any> => {
  return request({
    url: StatisticalEnumApi.LOCATIONVIEW_UPDATE,
    method: 'post',
    data
  })
}
export const lockLocationView = (data: any): ConfigType<any> => {
  return request({
    url: StatisticalEnumApi.LOCATIONVIEW_LOCK,
    method: 'post',
    data
  })
}

export const setLocationEmpty = (data: any): ConfigType<any> => {
  return request({
    url: '/LoactionView/ChangeIdle',
    method: 'post',
    data
  })
}

//********************************出入库明细*******************************//
export const getInAndOutDetails = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.INANDOUTDETAILS}?${qs.stringify(data)}`,
    method: 'get'
  })
}

//********************************仓库统计*******************************//
export const getUserList = (): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.GETUSER}`,
    method: 'get'
  })
}

export const getReportForms = (data: any): ConfigType<any> => {
  return request({
    url: `${StatisticalEnumApi.GETREPORTFORMS}?${qs.stringify(data)}`,
    method: 'get'
  })
}

// *****************************报表查询*******************************//

export const GetMoreexportData = (data: any): ConfigType<any> => {
  return request({
    url: StatisticalEnumApi.Moreexport,
    method: 'post',
    data
  })
}